import ReactDOM from "react-dom/client";
import { msalInstance } from "./config/authConfig";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import config from "devextreme/core/config";
import "./index.css";
import "./themes/dx.generic.ap-custom-scheme.css";
import "./themes/dx.generic.ap-custom-scheme-extertion-expansion.css";

var licenseKey = process.env.REACT_APP_DEVEXTREME_KEY;
config({ licenseKey });

// When loginPopup redirects back to this origin, the app loads inside the
// popup window. MSAL calls initialize() to process the auth response and
// signal the opener. We must NOT render the React app in that context —
// doing so causes React Router <Navigate> to call history.push, which
// Firefox blocks as insecure inside a popup security context.
msalInstance.initialize().then(() => {
  if (window.opener && window.opener !== window) {
    // Running inside the MSAL popup — let MSAL handle it, skip rendering.
    return;
  }

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(<App />);

  reportWebVitals();
});
